export default {
  computed: {
    labelStyle() {
      return this.question.subtype === 'header' ? 'is-size-4' : null;
    },
  },

  data() {
    return {
      isBlurred: true,
    };
  },
};
